@if(isLoading) {
  <app-loader></app-loader>
}
<div class="home-container">
  <div class="quiz-form-section-container">
    <div class="logo-container">
      <img
        src="assets/WatchGuard_Logo.svg"
        alt="logo"
        height="80" 
        width="auto" 
        class="logo"
      />
    </div>
    
    <h1 class="red">{{ candidateFormUIString.organization_title }}</h1>
    <p>{{ candidateFormUIString.organization_description }}</p>
    <div class="message">
      <p class="verify-message">{{candidateDetailUIString.resume_instruction}}</p>
      <p class="note-message">{{candidateDetailUIString.note_message}}</p>
    </div>
  </div>
  <div class="quiz-form-section-container">
    <form
      class="candidate-form"
      [formGroup]="candidateDetailsForm"
    >
      <div class="candidate-form-input">
        <p-floatLabel>
          <input
            id="name"
            type="text"
            formControlName="name"
            pInputText
          />
          <label for="name">
           {{candidateDetailUIString.name}}
          </label>
        </p-floatLabel>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('name')?.touched && 
            (!candidateDetailsForm.get('name')?.value)">
          {{candidateDetailUIString.error_message.name_required}}
        </small>
      </div>
      <div class="candidate-form-input">
        <p-floatLabel>
          <input
            id="mobile"
            type="number"
            formControlName="mobile"
            pInputText
          />
          <label for="mobile">
            {{candidateDetailUIString.mobile}}
          </label>
        </p-floatLabel>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('mobile')?.touched && 
            (!candidateDetailsForm.get('mobile')?.value)">
          {{candidateDetailUIString.error_message.number_required}}
        </small>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('mobile')?.value && 
            candidateDetailsForm.get('mobile')?.invalid">
          {{candidateDetailUIString.error_message.number_invalid}}
        </small>
      </div>
      <div class="candidate-form-input">
        <p-floatLabel>
          <input
            id="cgpa"
            type="text"
            formControlName="cgpa"
            pInputText
          />
          <label for="cgpa">
            {{candidateDetailUIString.cgpa}}
          </label>
        </p-floatLabel>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('cgpa')?.touched && 
            (!candidateDetailsForm.get('cgpa')?.value)">
          {{candidateDetailUIString.error_message.cgpa_required}}
        </small>
        <small 
          class="error-message"
          *ngIf="candidateDetailsForm.get('cgpa')?.value && 
            candidateDetailsForm.get('cgpa')?.errors?.['pattern']">
          {{candidateDetailUIString.error_message.cgpa_invalid}}
        </small>
      </div>
    <div class="candidate-form-input">
      <div class="upload-area">
        <div class="upload-input">
          <input
            type="file"
            formControlName="resume"
            accept=".pdf" 
            #fileInput
            style="display: none"
            (change)="uploadResume($event)"
          />
          <p-button
            severity="danger"
            icon="pi pi-upload"
            [label]="candidateDetailUIString.upload_resume"
            [outlined]="true"
            [disabled]="isLoading"
            class="file-upload-btn"
            (click)="fileInput.click()"
          ></p-button>
        </div>
        <div class="upload-message">
          @if (uploadedFileName) {
            {{candidateDetailUIString.change_message}}
          }@else {
            {{candidateDetailUIString.upload_message}}
          }
        </div>
      </div>
      <div class="uploaded-file-info" [class.success]="uploadedFileName" *ngIf="uploadedFileName">
        <span class="file-name">
          <i class="pi pi-file-pdf"></i>
          {{ uploadedFileName }}
        </span>
        <button 
          type="button" 
          class="remove-file-btn"
          (click)="removeFile()"
          [disabled]="isLoading"
          title="Remove file">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <small 
        class="error-message"
        *ngIf="candidateDetailsForm.get('resume')?.touched && 
          (!candidateDetailsForm.get('resume')?.value)">
        {{candidateDetailUIString.error_message.resume_required}}
      </small>
      <small 
        class="error-message"
        *ngIf="
          candidateDetailsForm.get('resume')?.invalid && 
          candidateDetailsForm.get('resume')?.value">
        {{fileErrorMessage}}
      </small>
    </div>
      <div class="btn-center">
        <p-button
          type="submit"
          class="btn-design"
          severity="success"
          [label]="candidateDetailUIString.next"
          [outlined]="true"
          [disabled]="candidateDetailsForm.invalid"
          (click)="saveAndNext()"
        ></p-button>
      </div>
    </form>
  </div>
</div>
